import React, { ReactNode } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Avatar, Card, CardActionArea, CardHeader, IconButton } from '@mui/material';
import { Link } from 'react-router';

import { MenuAnchor } from '@paragon/client-tools';

interface BaseCardProps {
  title: string;
  subheader?: ReactNode;
  avatar: ReactNode;
  linkTo?: string;
  onSetMenuAnchor: (anchor: MenuAnchor) => void;
  menu?: ReactNode;
}

export function BaseCard({ title, subheader, avatar, linkTo, menu, onSetMenuAnchor }: BaseCardProps) {
  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    onSetMenuAnchor({ x: event.clientX, y: event.clientY });
  };

  const handleActionClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onSetMenuAnchor({ current: event.currentTarget as HTMLElement });
  };

  const defaultAction = menu ? (
    <IconButton onClick={handleActionClick}>
      <MoreVertIcon />
    </IconButton>
  ) : undefined;

  const cardHeader = (
    <CardHeader title={title} subheader={subheader} avatar={<Avatar>{avatar}</Avatar>} action={defaultAction} />
  );

  return (
    <>
      {menu}

      <Card>
        {linkTo ? (
          /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
          /* @ts-ignore */
          <CardActionArea LinkComponent={Link} to={linkTo} onContextMenu={handleContextMenu}>
            {cardHeader}
          </CardActionArea>
        ) : (
          <div onContextMenu={handleContextMenu}>{cardHeader}</div>
        )}
      </Card>
    </>
  );
}
